import { useRef, useState } from "react";

import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Card } from "primereact/card";
import { Dropdown } from "primereact/dropdown";
import { Toast } from "primereact/toast";

import AcabamentoTabelaParadas from "../../../components/Sanforizadeira/TabelaParadas";
import { GraficoParadas } from "../../../components/Sanforizadeira/GraficoParadas";
import Loading from "../../../components/Loading";
import Menu from "../../../components/Menu";

import api from "../../../services/api";

export default function AcabamentoRelatorio() {
    const [data, setData] = useState(null);
    const [report, setReport] = useState('');

    const [initialDate, setInitialDate] = useState(new Date());
    const [finalDate, setFinalDate] = useState(new Date()); 

    const [isLoading, setIsLoading] = useState(false);

    const toast = useRef();

    const handleSearch = () => {
        if(!initialDate || !finalDate) {
            toast.current.show({ summary: 'Aviso', severity: 'warn', detail: 'Preencha as datas corretamente para continuar.' })
            return
        }
        
        let search = {}

        search.data_inicial = initialDate.getFullYear() + '-' + (initialDate.getMonth() + 1).toString().padStart(2, '0') + '-' + initialDate.getDate().toString().padStart(2, '0');
        search.data_final = finalDate.getFullYear() + '-' + (finalDate.getMonth() + 1).toString().padStart(2, '0') + '-' + finalDate.getDate().toString().padStart(2, '0');
        search.report = report;

        setIsLoading(true);
        api.post('acabamento/report', search).then(response => {
            setData(response.data);
            setIsLoading(false);
        }).catch(error => {
            setIsLoading(false);
            setData(null);
        });
    }

    if(isLoading)
        return <Loading />

    return (
        <div>
            <Menu />
            <Toast />
            <Card
                title="Relatórios"
            >
                <div className="p-d-flex p-flex-row p-jc-start">
                    <Dropdown 
                        onChange={e => setReport(e.value)}
                        options={[
                            { label: 'Paradas', value: 'paradas' }
                        ]}
                        style={{ minWidth: 200 }}
                        value={report}
                    />

                    <Calendar
                        className="p-ml-2"
                        dateFormat="dd/mm/yy"
                        mask="99/99/9999"
                        onChange={e => setInitialDate(e.value)}
                        placeholder="Data Inicial"
                        value={initialDate}
                    />

                    <Calendar
                        className="p-ml-2"
                        dateFormat="dd/mm/yy"
                        mask="99/99/9999"
                        onChange={e => setFinalDate(e.value)}
                        placeholder="Data Final"
                        value={finalDate}
                    />

                    <Button 
                        className="p-button-success p-ml-2"
                        icon="pi pi-search"
                        onClick={handleSearch}
                    />
                </div>

                {data !== null && report === 'paradas' && (
                    <>
                        <AcabamentoTabelaParadas data={data} />
                        <GraficoParadas
                            data={data}
                        />
                    </>
                )}
            </Card>
        </div>
    )
}